var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"availibility-status-container",on:{"click":_vm.statusClicked}},[_c('div',{class:_vm.avaibilityStatusBoxClass},[_c('common-icon',{attrs:{"name":"white-check","size":"small"}})],1),_c('div',{staticClass:"availability-status-text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }